var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7495 15.5768C12.7495 16.0902 12.5341 16.5064 12 16.5064C11.4659 16.5064 11.2505 16.0902 11.2505 15.5768M12.7495 15.5768C12.7495 15.0634 12.5341 14.6472 12 14.6472C11.4659 14.6472 11.2505 15.0634 11.2505 15.5768M12.7495 15.5768C12.7495 14.7663 15.984 12.3231 15.984 15.5768C15.984 18.8304 12.7495 16.3873 12.7495 15.5768ZM11.2505 15.5768C11.2505 14.7663 8.01603 12.3231 8.01603 15.5768C8.01603 18.8304 11.2505 16.3873 11.2505 15.5768ZM16.0955 15.6258C19.4107 16.5563 22 18.6811 22 22H2C2 18.6947 4.5681 16.5737 7.86382 15.6372M12 12C14.7614 12 17 9.76142 17 7C17 6.61812 16.9572 6.24623 16.8761 5.88889C16.7554 5.35707 16.55 4.85744 16.2747 4.40498C15.3975 2.96303 13.8112 2 12 2C10.9328 2 9.94368 2.33435 9.1317 2.90401C8.6247 3.25971 8.18675 3.70715 7.84197 4.22222C7.31015 5.01672 7 5.97214 7 7C7 9.76142 9.23858 12 12 12Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigner);
export default __webpack_public_path__ + "static/media/designer.2a72ae8d0aa8d7da4ad2e7db81766261.svg";
export { ForwardRef as ReactComponent };